var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#B88333",
    stroke: "#B88333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8214 7.07576C14.0143 7.20533 14.0571 7.45776 13.9196 7.6395L9.20588 13.8323C9.13267 13.9282 9.0184 13.9905 8.89342 13.9989C8.76843 14.0073 8.64345 13.9669 8.55417 13.8828L6.12588 11.5941C5.95804 11.436 5.95804 11.1802 6.12588 11.0237C6.29372 10.8672 6.56511 10.8655 6.73117 11.0237L8.80414 12.9741L13.2233 7.16831C13.3608 6.98657 13.6286 6.94618 13.8214 7.07576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGold);
export default __webpack_public_path__ + "static/media/check-circle-gold.24a10d8d5ac7199ce7257e856388e1b1.svg";
export { ForwardRef as ReactComponent };